// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.questionnaire-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.questionnaire-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  position: relative;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-height: 80vh;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #adafb0 #f0f0f0;
}

.modal-close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
}

.modal-close-btn:hover {
  color: #1a73e8;
}

.form-title {
  text-align: center;
  color: #333;
  margin-bottom: 2rem;
  font-size: 1.8rem;
}

.vertical-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-weight: 500;
  color: #555;
}

.form-group select {
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  background-color: #f8f9fa;
}

.form-group select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.button-group {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.submit-btn {
  background-color: #007bff;
  color: white;
  padding: 0.75rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
  flex: 1 1;
}

.submit-btn:hover {
  background-color: #0056b3;
}

.cancel-btn {
  background-color: #6c757d;
  color: white;
  padding: 0.75rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
  flex: 1 1;
}

.cancel-btn:hover {
  background-color: #545b62;
}

.error-message {
  color: #dc3545;
  text-align: center;
  margin-bottom: 1rem;
}

/* Custom scrollbar styling for webkit browsers */
.questionnaire-content::-webkit-scrollbar {
  width: 8px;
}

.questionnaire-content::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 4px;
}

.questionnaire-content::-webkit-scrollbar-thumb {
  background: #838587;
  border-radius: 4px;
}

.questionnaire-content::-webkit-scrollbar-thumb:hover {
  background: #8c8f91;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .questionnaire-content {
      width: 95%;
      padding: 1.5rem;
      margin: 10px;
      max-height: 85vh;
  }
  
  .form-title {
      font-size: 1.5rem;
      margin-bottom: 1.5rem;
  }
  
  .vertical-form {
      gap: 1.2rem;
  }
  
  .form-group select {
      padding: 0.8rem;
      font-size: 16px; /* Prevents zoom on iOS */
  }
  
  .button-group {
      flex-direction: column;
      gap: 0.8rem;
  }
  
  .submit-btn,
  .cancel-btn {
      width: 100%;
      padding: 0.9rem;
  }
  
  .modal-close-btn {
      top: 0.8rem;
      right: 0.8rem;
      font-size: 1.3rem;
  }
}

@media (max-width: 480px) {
  .questionnaire-content {
      width: 98%;
      padding: 1rem;
  }
  
  .form-title {
      font-size: 1.3rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/Questionnaire.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,SAAO;AACT;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,SAAO;AACT;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE;MACI,UAAU;MACV,eAAe;MACf,YAAY;MACZ,gBAAgB;EACpB;;EAEA;MACI,iBAAiB;MACjB,qBAAqB;EACzB;;EAEA;MACI,WAAW;EACf;;EAEA;MACI,eAAe;MACf,eAAe,EAAE,yBAAyB;EAC9C;;EAEA;MACI,sBAAsB;MACtB,WAAW;EACf;;EAEA;;MAEI,WAAW;MACX,eAAe;EACnB;;EAEA;MACI,WAAW;MACX,aAAa;MACb,iBAAiB;EACrB;AACF;;AAEA;EACE;MACI,UAAU;MACV,aAAa;EACjB;;EAEA;MACI,iBAAiB;EACrB;AACF","sourcesContent":[".questionnaire-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.questionnaire-content {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 500px;\n  position: relative;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  max-height: 80vh;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #adafb0 #f0f0f0;\n}\n\n.modal-close-btn {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #666;\n}\n\n.modal-close-btn:hover {\n  color: #1a73e8;\n}\n\n.form-title {\n  text-align: center;\n  color: #333;\n  margin-bottom: 2rem;\n  font-size: 1.8rem;\n}\n\n.vertical-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.form-group label {\n  font-weight: 500;\n  color: #555;\n}\n\n.form-group select {\n  padding: 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n  background-color: #f8f9fa;\n}\n\n.form-group select:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.button-group {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.submit-btn {\n  background-color: #007bff;\n  color: white;\n  padding: 0.75rem;\n  border: none;\n  border-radius: 4px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  flex: 1;\n}\n\n.submit-btn:hover {\n  background-color: #0056b3;\n}\n\n.cancel-btn {\n  background-color: #6c757d;\n  color: white;\n  padding: 0.75rem;\n  border: none;\n  border-radius: 4px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  flex: 1;\n}\n\n.cancel-btn:hover {\n  background-color: #545b62;\n}\n\n.error-message {\n  color: #dc3545;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n/* Custom scrollbar styling for webkit browsers */\n.questionnaire-content::-webkit-scrollbar {\n  width: 8px;\n}\n\n.questionnaire-content::-webkit-scrollbar-track {\n  background: #f0f0f0;\n  border-radius: 4px;\n}\n\n.questionnaire-content::-webkit-scrollbar-thumb {\n  background: #838587;\n  border-radius: 4px;\n}\n\n.questionnaire-content::-webkit-scrollbar-thumb:hover {\n  background: #8c8f91;\n}\n\n/* Mobile Responsiveness */\n@media (max-width: 768px) {\n  .questionnaire-content {\n      width: 95%;\n      padding: 1.5rem;\n      margin: 10px;\n      max-height: 85vh;\n  }\n  \n  .form-title {\n      font-size: 1.5rem;\n      margin-bottom: 1.5rem;\n  }\n  \n  .vertical-form {\n      gap: 1.2rem;\n  }\n  \n  .form-group select {\n      padding: 0.8rem;\n      font-size: 16px; /* Prevents zoom on iOS */\n  }\n  \n  .button-group {\n      flex-direction: column;\n      gap: 0.8rem;\n  }\n  \n  .submit-btn,\n  .cancel-btn {\n      width: 100%;\n      padding: 0.9rem;\n  }\n  \n  .modal-close-btn {\n      top: 0.8rem;\n      right: 0.8rem;\n      font-size: 1.3rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .questionnaire-content {\n      width: 98%;\n      padding: 1rem;\n  }\n  \n  .form-title {\n      font-size: 1.3rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
